/**
 * Committee entity index page
 */

import { EntityIndex } from './base';
import { canonicalPath, Constants } from '@electinfo/common';
import type { EntityConfig, EntitySearchResult } from './types';

function formatCurrency(amount: number): string {
  if (amount >= 1_000_000_000) {
    return `$${(amount / 1_000_000_000).toFixed(1)}B`;
  } else if (amount >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(1)}M`;
  } else if (amount >= 1_000) {
    return `$${(amount / 1_000).toFixed(0)}K`;
  }
  return `$${amount.toLocaleString()}`;
}

class CommitteeIndex extends EntityIndex {
  getConfig(): EntityConfig {
    return {
      entityType: 'Committee',
      placeholder: 'Search committees by name...',
      browseTitle: 'All Committees',
      sortField: 'total_dollars',
      sortOrder: 'DESC',
      filterDropdown: {
        label: 'Committee Type',
        options: [
          { value: 'H', label: 'House Campaign' },
          { value: 'S', label: 'Senate Campaign' },
          { value: 'P', label: 'Presidential Campaign' },
          { value: 'N', label: 'PAC - Nonqualified' },
          { value: 'Q', label: 'PAC - Qualified' },
          { value: 'O', label: 'Super PAC' },
          { value: 'X', label: 'Party - Nonqualified' },
          { value: 'Y', label: 'Party - Qualified' },
          { value: 'Z', label: 'National Party' },
          { value: 'I', label: 'Independent Expenditure' },
          { value: 'E', label: 'Electioneering' },
          { value: 'C', label: 'Communication Cost' },
          { value: 'D', label: 'Delegate Committee' },
          { value: 'U', label: 'Single Candidate' },
          { value: 'V', label: 'PAC with Non-Contribution' },
          { value: 'W', label: 'PAC without Non-Contribution' }
        ]
      },
      formatResult: (result: EntitySearchResult) => {
        const committeeType = result.committee_type || '';
        const typeName = Constants.committeeTypeNames[committeeType] || 'Committee';
        const totalDollars = result.score ? formatCurrency(result.score) : '';
        const metaParts = [typeName, totalDollars ? `${totalDollars} total dollars` : ''].filter(Boolean);

        return {
          url: `/${canonicalPath('Committee', result.id)}/`,
          name: result.name || '',
          meta: metaParts.join(' - ')
        };
      }
    };
  }
}

new CommitteeIndex();
